export const validateInput = (inputData, schema, schemaType, type = null) => {
  let errors = {};
  let status = true;

  // console.log(Object.keys(schemaType[schema],"Keys Name"));
  //   return false;

  // Get keys to validate based on the `type` parameter
  const keysToValidate = type ? [type] : Object.keys(schemaType[schema]);

  keysToValidate.forEach((key) => {
    const field = schemaType[schema][key];
    const value = inputData[key];
    // console.log(value,"Value of keys");

    // Check for required fields
    if (
      field?.required &&
      (value === undefined || value === "" || value === null)
    ) {
      errors[key] = field?.message;
      if (field?.extraMessage) {
        errors[`${key}Err`] = true;
      }
      status = false;
      return; // Exit early since this field has already failed
    }

    // Validate using the custom `validate` function
    if (field?.validate) {
      const isValid = Array.isArray(value)
        ? field.validate(value, inputData)
        : field.validate(String(value), inputData);
      if (!isValid) {
        errors[key] = field?.invalidMessage;
        if (field?.extraMessage) {
          errors[`${key}Err`] = true;
        }
        status = false;
      }
    }
  });

  return { errors, status };
};

export const removeErrorFields = (errorObject, fieldName) => {
  const updatedError = { ...errorObject };

  // Remove the specific field and its associated error
  if (updatedError[fieldName]) delete updatedError[fieldName];
  if (updatedError[`${fieldName}Err`]) delete updatedError[`${fieldName}Err`];

  return updatedError;
};
